module.exports = __webpack_public_path__ + "static/img/14g.f35483c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/14g.jpg
// module id = cflr
// module chunks = 0